'use client'
import { createContext } from 'react'
import type { AccountsContextType } from './types'

export const AccountContext = createContext<AccountsContextType | null>(null)
